// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__BXRdb","main":"Layout_main__02m6p"};